import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { FilesetShellComponent } from '../../../fileset-runtime/src/public-api';
import { FilesetRuntimeModule } from '../../../fileset-runtime/src/public-api';


import { NoopAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        FilesetRuntimeModule,
        NoopAnimationsModule,
    ],
    providers: []
})
export class AppModule {
  constructor(private injector: Injector) {

  }

  ngDoBootstrap() {
    const FILE_SET_TAG = 'lf-fileset-shell';

    const customEle = createCustomElement(FilesetShellComponent, { injector: this.injector });
    customElements.get(FILE_SET_TAG) || customElements.define(FILE_SET_TAG, customEle);

  }
}
